module.exports = __webpack_public_path__ + "img/floating-image-2@2x.0b93c916.png";